/** Mirrors the `partner_custom_domain_status` DB enum. */
export enum CgCustomDomainStatus {
  PendingValidation = 'pending_validation',
  Validated = 'validated',
  Active = 'active',
  Failed = 'failed',
  Removed = 'removed',
}

export enum CgCustomDomainRoutingRecord {
  Found = 'found',
  Missing = 'missing',
  WrongValue = 'wrong_value',
}

export enum CgCustomDomainHostnameError {
  Invalid = 'invalid',
  RootDomain = 'root_domain',
}

// DNS limits (RFC 1035): 253 characters per name, 63 per label, letters/digits/hyphens.
const MAX_HOSTNAME_LENGTH = 253;
const HOSTNAME_LABEL = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;
// e.g. membership.partner.com: the apex (partner.com) can't hold a CNAME.
const MIN_SUBDOMAIN_LABELS = 3;

export interface ParsedCgCustomDomainHostname {
  hostname: string;
  error: CgCustomDomainHostnameError | null;
}

export function parseCgCustomDomainHostname(raw: string): ParsedCgCustomDomainHostname {
  const hostname = raw
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/[/?#].*$/, '')
    .replace(/\.$/, '');

  const labels = hostname.split('.');

  if (
    hostname.length > MAX_HOSTNAME_LENGTH ||
    labels.length < 2 ||
    !labels.every((label) => HOSTNAME_LABEL.test(label))
  ) {
    return { hostname, error: CgCustomDomainHostnameError.Invalid };
  }

  if (labels.length < MIN_SUBDOMAIN_LABELS) {
    return { hostname, error: CgCustomDomainHostnameError.RootDomain };
  }

  return { hostname, error: null };
}
